import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 23950 15231"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#252422}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="M531 1028c0-274 223-497 497-497h1603c274 0 497 223 497 497v7478h17694V6091c0-274 223-497 497-497h1603c274 0 497 223 497 497v8113c0 274-223 497-497 497h-1603c-274 0-497-223-497-497v-3100H3128v3100c0 274-223 497-497 497H1028c-274 0-497-223-497-497V1028zm497 14203h1603c567 0 1027-461 1027-1027v-2570h16633v2570c0 566 461 1027 1028 1027h1603c567 0 1028-461 1028-1027V6091c0-567-461-1028-1028-1028h-1603c-567 0-1028 461-1028 1028v1885H3658V1028C3658 461 3198 0 2631 0H1028C461 0 0 461 0 1028v13176c0 566 461 1027 1028 1027z"
        className="fil0"
      />
      <path
        d="M5641 4303h865c565 0 1024 564 1024 1258s-459 1259-1024 1259h-865c-565 0-1025-565-1025-1259 1-694 460-1258 1025-1258zm0 3047h865c858 0 1555-802 1555-1789 0-986-697-1789-1555-1789h-865c-857 0-1555 803-1555 1789 0 987 698 1789 1555 1789zM9019 6820V4251c0-296 241-537 537-537h6964c1477 0 2691 1371 2805 3106H9019zm10845 265c0-2151-1500-3901-3344-3901H9556c-589 0-1068 479-1068 1067v3099h11376v-265z"
        className="fil0"
      />
    </g>
  </svg>
)
export default SvgComponent
